import { render } from "./ObjManageAdd.vue?vue&type=template&id=6213ba38&scoped=true"
import script from "./ObjManageAdd.vue?vue&type=script&lang=js"
export * from "./ObjManageAdd.vue?vue&type=script&lang=js"

import "./ObjManageAdd.vue?vue&type=style&index=0&id=6213ba38&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6213ba38"]])

export default __exports__